export default __webpack_public_path__ + "static/media/img-evpower-full.45250060.svg";